import React, { useEffect } from 'react';
import { EmailPageBase } from 'components/EmailPageBase/EmailPageBase';
import './style.scss';
import { Button } from 'components/Button/Button';
import { useHistory } from 'react-router-dom';
import { userApi } from 'helpers/api/user';

export const RegistrationSuccessful = () => {
  const history = useHistory();
  const userID = new URLSearchParams(window.location.search).get('key') || '';
  useEffect(() => {
    userApi.activateUser(userID);
  }, [userID]);
  const handleClick = () => {
    history.push('/login');
  };

  return (
    <EmailPageBase>
      <h3 className="title-email">Почта подтверждена!</h3>
      <p className="text-content">
        Осталось только попросить администратора системы добавить вам ваши отделения и можно начинать!
      </p>
      <Button onClick={handleClick} className="btn-form">
        На страницу авторизации
      </Button>
    </EmailPageBase>
  );
};
